import { Route, Switch } from 'react-router-dom';
import { getPortalBasename } from 'portals-platform-lib';
import KitchenSink from '../containers/KitchenSink';
import TokenExplorer from '../containers/TokenExplorer';
import { ProjectPOC } from '../containers/ProjectPOC';
import { Settings } from '../containers/Settings';
import { RouterProvider } from 'quartz-core/routing';
// @bend-expect quartz-no-create-browser-history
import { createBrowserHistory } from 'history';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Routes = () => {
  var _getPortalBasename;
  const history = createBrowserHistory({
    basename: (_getPortalBasename = getPortalBasename()) !== null && _getPortalBasename !== void 0 ? _getPortalBasename : '/portals-platform-reference-fe'
  });
  return /*#__PURE__*/_jsx(RouterProvider, {
    history: history,
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/",
        exact: true,
        children: /*#__PURE__*/_jsx(KitchenSink, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/component-examples",
        exact: true,
        children: /*#__PURE__*/_jsx(KitchenSink, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/token-explorer",
        exact: true,
        children: /*#__PURE__*/_jsx(TokenExplorer, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/projects/:id",
        exact: true,
        children: /*#__PURE__*/_jsx(ProjectPOC, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/projects",
        exact: true,
        children: /*#__PURE__*/_jsx(ProjectPOC, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/settings",
        exact: true,
        children: /*#__PURE__*/_jsx(Settings, {})
      })]
    })
  });
};